import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.GWMonitoring.deleteConfirmTitle'),
      "open": _vm.deletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('NiotaClassic.Common.deleteButton'),
        color: _vm.color,
        emit: 'delete'
      }],
      "color": _vm.color
    },
    on: {
      "cancel": function ($event) {
        _vm.deletePrompt = false;
      },
      "delete": _vm.deleteItem
    }
  }), _vm.accountId ? _c(VRow, {
    attrs: {
      "justify": "end"
    }
  }, [_c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c(VCheckbox, {
    staticClass: "py-0 my-2",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.includeSubAccounts'),
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.includeSubAccounts,
      callback: function ($$v) {
        _vm.includeSubAccounts = $$v;
      },
      expression: "includeSubAccounts"
    }
  })], 1)], 1) : _vm._e(), _c(VRow, [_c(VCol, {
    staticClass: "pb-0"
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "auto",
      "single-line": "",
      "clearable": "",
      "dense": ""
    },
    model: {
      value: _vm.searchItem,
      callback: function ($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  })], 1)], 1), _c(VDataTable, {
    staticClass: "row-pointer",
    attrs: {
      "items": _vm.gateways,
      "loading": _vm.isFetching,
      "headers": _vm.tableLocalizations.headers,
      "options": _vm.tableOptions,
      "footer-props": _vm.tableLocalizations.tableFooterProps,
      "server-items-length": _vm.serverItemsLength,
      "item-key": "id",
      "page": _vm.tableOptions.page
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      },
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('tr', {
          on: {
            "click": function ($event) {
              return _vm.openDetails(items.item);
            }
          }
        }, [_c('td', {
          staticClass: "px-0 text-center",
          staticStyle: {
            "width": "10px"
          }
        }, [_c(VIcon, {
          attrs: {
            "small": "",
            "color": _vm.getState(items.item)
          }
        }, [_vm._v("fal fa-circle")])], 1), _c('td', {
          staticClass: "px-0 text-center",
          staticStyle: {
            "width": "60px"
          }
        }, [_vm._v(_vm._s(items.item.id))]), _c('td', {
          staticClass: "text-truncate"
        }, [_c('router-link', {
          attrs: {
            "to": `/niota-classic/gw-mgmt/${items.item.id}/details`
          }
        }, [_vm._v("\n            " + _vm._s(items.item.title) + "\n          ")])], 1), _c('td', [_vm.isCopySupported() ? _c('div', {
          staticClass: "euiElement",
          on: {
            "click": function ($event) {
              return _vm.copyToClipboard($event, items.item.eui);
            }
          }
        }, [_c('pre', [_vm._v(_vm._s(items.item.eui))]), _c(VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-copy")])], 1) : _c('div', {
          staticClass: "euiElement"
        }, [_c('pre', [_vm._v(_vm._s(items.item.eui))])])]), _c('td', [_vm._v("\n          " + _vm._s(items.item.countPackets || 0) + "\n          "), _c('p', {
          staticStyle: {
            "margin": "0",
            "font-size": "10px !important"
          }
        })]), _c('td', [_vm._v(_vm._s(_vm.lastPacket(items.item)))]), _c('td', [_vm._v(_vm._s(_vm.getRssi(items.item)))]), _c('td', {
          staticClass: "text-truncate max100"
        }, [_vm._v(_vm._s(_vm.getAccount(items.item)))]), _c('td', [_vm._v(_vm._s(_vm.getGroup(items.item)))]), _c('td', {
          staticStyle: {
            "min-width": "86px"
          }
        }, [_vm.editable && _vm.isIotHubManager ? [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.edit'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.$emit('edit-item', items.item);
            }
          }
        }, [_vm._v("\n              fal fa-edit\n            ")]), _vm._v("\n             \n            "), _vm.isIotHubManager ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.showPrompt(items.item);
            }
          }
        }, [_vm._v("\n              fal fa-trash-alt\n            ")]) : _vm._e()] : _vm._e()], 2)])];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n          " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n        ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n      ")])];
      },
      proxy: true
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };